// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Story source reference badge + source chunk drawer (light/dark via theme tokens) */

.rt-story-summary {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.rt-story-summary__text {
  min-width: 0;
}

.rt-source-ref {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  height: 22px;
  padding: 0 8px;
  border: 1px solid color-mix(in srgb, var(--primary) 28%, transparent);
  border-radius: var(--radius-full);
  background: var(--primary-muted);
  color: var(--primary);
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.rt-source-ref:hover {
  background: color-mix(in srgb, var(--primary) 18%, transparent);
  border-color: color-mix(in srgb, var(--primary) 50%, transparent);
}

.rt-source-ref:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

.rt-source-ref--static {
  cursor: default;
}

.rt-source-ref--static:hover {
  background: var(--primary-muted);
  border-color: color-mix(in srgb, var(--primary) 28%, transparent);
}

[data-theme='dark'] .rt-source-ref {
  color: var(--primary-hover);
  border-color: color-mix(in srgb, var(--primary) 40%, transparent);
}

[data-theme='dark'] .rt-source-ref:hover {
  background: color-mix(in srgb, var(--primary) 26%, transparent);
}

/* Drawer content */
.rt-source-chunk {
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: var(--text-primary);
}

.rt-source-chunk__meta {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  justify-content: start;
  gap: 12px 28px;
  margin: 0;
  padding: 12px 14px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--bg-tertiary);
}

.rt-source-chunk__meta dt {
  margin-bottom: 4px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.rt-source-chunk__meta dd {
  margin: 0;
  font-size: 13px;
  color: var(--text-primary);
}

.rt-source-chunk__doc {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  word-break: break-word;
}

.rt-source-chunk__doc svg {
  flex-shrink: 0;
  color: var(--text-secondary);
}

.rt-source-chunk__label {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
}

.rt-source-chunk__text {
  margin: -8px 0 0;
  padding: 14px 16px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--surface);
  color: var(--text-primary);
  font-family: inherit;
  font-size: 13px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
}

@media (max-width: 640px) {
  .rt-source-chunk__meta {
    grid-template-columns: minmax(0, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/source-reference.css"],"names":[],"mappings":"AAAA,qFAAqF;;AAErF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,cAAc;EACd,qEAAqE;EACrE,iCAAiC;EACjC,gCAAgC;EAChC,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,+DAA+D;EAC/D,iEAAiE;AACnE;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,iEAAiE;AACnE;;AAEA;EACE,2BAA2B;EAC3B,iEAAiE;AACnE;;AAEA;EACE,+DAA+D;AACjE;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,sBAAsB;EACtB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":["/* Story source reference badge + source chunk drawer (light/dark via theme tokens) */\n\n.rt-story-summary {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.rt-story-summary__text {\n  min-width: 0;\n}\n\n.rt-source-ref {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n  height: 22px;\n  padding: 0 8px;\n  border: 1px solid color-mix(in srgb, var(--primary) 28%, transparent);\n  border-radius: var(--radius-full);\n  background: var(--primary-muted);\n  color: var(--primary);\n  font-family: var(--font-mono);\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.rt-source-ref:hover {\n  background: color-mix(in srgb, var(--primary) 18%, transparent);\n  border-color: color-mix(in srgb, var(--primary) 50%, transparent);\n}\n\n.rt-source-ref:focus-visible {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n}\n\n.rt-source-ref--static {\n  cursor: default;\n}\n\n.rt-source-ref--static:hover {\n  background: var(--primary-muted);\n  border-color: color-mix(in srgb, var(--primary) 28%, transparent);\n}\n\n[data-theme='dark'] .rt-source-ref {\n  color: var(--primary-hover);\n  border-color: color-mix(in srgb, var(--primary) 40%, transparent);\n}\n\n[data-theme='dark'] .rt-source-ref:hover {\n  background: color-mix(in srgb, var(--primary) 26%, transparent);\n}\n\n/* Drawer content */\n.rt-source-chunk {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  color: var(--text-primary);\n}\n\n.rt-source-chunk__meta {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  justify-content: start;\n  gap: 12px 28px;\n  margin: 0;\n  padding: 12px 14px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  background: var(--bg-tertiary);\n}\n\n.rt-source-chunk__meta dt {\n  margin-bottom: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.rt-source-chunk__meta dd {\n  margin: 0;\n  font-size: 13px;\n  color: var(--text-primary);\n}\n\n.rt-source-chunk__doc {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  word-break: break-word;\n}\n\n.rt-source-chunk__doc svg {\n  flex-shrink: 0;\n  color: var(--text-secondary);\n}\n\n.rt-source-chunk__label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.rt-source-chunk__text {\n  margin: -8px 0 0;\n  padding: 14px 16px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  background: var(--surface);\n  color: var(--text-primary);\n  font-family: inherit;\n  font-size: 13px;\n  line-height: 1.6;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n@media (max-width: 640px) {\n  .rt-source-chunk__meta {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
